module.exports = __webpack_public_path__ + "static/img/cc4_07.75dc917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/cc4_07.png
// module id = PtKp
// module chunks = 3